let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page035_game10/img/bcg3.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 279,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '12',
      animation: true,
      direction: 'left',
      textObj: {
        text: 'Wstawiaj inne obiekty, obracaj je i oglądaj podczas obrotów.',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-12.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1451,
        y: 347,
      },
    },
    {
      id: '13',
      // direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Zamknij.</i>',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-13.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1631,
        y: 163,
      },
    },
  ],
};
export default elements;
